import awsExports from './aws-exports';
import { initAmplify, getApiInterceptor } from 'services/amplify';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@aws-amplify/ui-react/styles.css';
import { Routes } from 'router/Routes';
import { AppProvider } from 'router/AppProvider';

initAmplify(awsExports);

function App() {
  return (
    <AppProvider>
      <Routes />
    </AppProvider>
  );
}

export default App;

// dont use this deprecatedApiInterceptor, use service adminAPI or other service instead deprecatedApiInterceptor
export const deprecatedApiInterceptor = getApiInterceptor();
